// ADDED: Payroll Reason Code Page
import React from "react";
import { GeneralMessage, useGeneralMessage } from "../../../common/APICommon";
import { LoadingSpinner } from "../../../common/Loading";
import { usePayrollReasonCode } from "../../hooks/usePayrollReasonCode";
import PayrollReasonCodeModule from "../../components/modules/PayrollReasonCode/PayrollReasonCodeModule";

const PayrollReasonCodePage = ({ user, isHideSideMenu }) => {
  const { showGeneralMessage, showMessage, message, isSuccess } = useGeneralMessage();
  const reasonCodeMethods = usePayrollReasonCode({showGeneralMessage});

  return (
    <>
      <div className={`MainBody row ${isHideSideMenu ? "MainBody2" : ""}`}>
        <div className="LeftSpace"></div>
        <div className={`BodySpace ${isHideSideMenu ? "BodySpace2" : ""}`}>
          <div className="MainteInfo shadow-xl bg-white rounded-lg">
            <div className="mainteHeader p-4 border-b">
              <div className='sub-title row text-sm'>
                <span className="text-gray-400">{"Maintenance > "}</span>
                <span className="border-b border-black">{"Payroll Reason Codes"}</span>
              </div>
              <h3 className="text-xl font-bold mt-2">Payroll Reason Codes</h3>
            </div>

            <PayrollReasonCodeModule
              user={user}
              {...reasonCodeMethods}
            />
          </div>
        </div>
      </div>

      <GeneralMessage
        form={showMessage}
        message={message}
        isSuccess={isSuccess}
      />

      <LoadingSpinner loading={reasonCodeMethods.loading} />
    </>
  );
};

export default PayrollReasonCodePage;